import * as React from 'react';
import type { Facet } from '../../../Search/Facet.csharp';
import type { SelectedFacet } from '../../../Search/SelectedFacet.csharp';
import { AccordionItem } from '../../AccordionComponent/AccordionItem';
import { List } from '../../List/List';
import { FacetItem } from './FacetItem';
import styles from './Shared/AccordionListShared.module.css';

interface FacetAccordionListProps {
    facets: Facet[];
    selectedFacets: SelectedFacet[];
    handleFacetChange: (newFacets: SelectedFacet[]) => void;
    initialExpanded?: boolean;
}

export const FacetsAccordionList: React.FunctionComponent<React.PropsWithChildren<FacetAccordionListProps>> = ({
    facets,
    selectedFacets,
    handleFacetChange,
    initialExpanded = false,
}) => (
    <List
        className={styles.List}
        items={facets}
        renderItem={(facet, index) =>
            facet.options?.length > 0 && (
                <li key={`${facet.label}__${index}`} className={styles.Item}>
                    <AccordionItem
                        headerContent={facet.label}
                        initialExpanded={initialExpanded}
                        contentSpacing="fullWidth"
                    >
                        <div>
                            <FacetItem facet={facet} selectedFacets={selectedFacets} onChange={handleFacetChange} />
                        </div>
                    </AccordionItem>
                </li>
            )
        }
    />
);
